/**
 * @file Emotions validator
 * @author Wim Haanstra
 */
import { Validator } from 'breeze-client';
var NAME_EMOTIONS_VALIDATOR = 'emotion';
var MAX_EMOTION_VALUE = 5;
/**
 * This validator validates the given emotion
 */
export function EmotionsValidator() {
    var contxt = {};
    var validator = new Validator(NAME_EMOTIONS_VALIDATOR, valFunction, contxt);
    return validator;
    function valFunction(value, context) {
        if (value === null) {
            return true;
        }
        var integerValue = +value;
        if (integerValue === null) {
            return false;
        }
        else {
            return (integerValue >= 0 && integerValue <= MAX_EMOTION_VALUE);
        }
    }
}
Validator.messageTemplates[NAME_EMOTIONS_VALIDATOR] = 'APP.DOMAIN.VALIDATORS.EMOTION';
Validator.register(EmotionsValidator());
